<template lang="pug">
  .maptalks-line-layer
    slot(v-if='ready')
</template>

<script>
import { createLineLayer } from '@/utils/map'
// import mixins from '@/utils/mixins'

export default {
  // mixins: [
  //   mixins.attachMapTooltip
  // ],
  props: {
    coordinates: {
      type: [Object, Array],
      required: true
    },
    lineColor: {
      type: String,
      default: '#ff0000'
    },
    lineWidth: {
      type: Number,
      default: 5
    },
    options: {
      type: Object,
      default: () => ({
        symbol: {
          lineColor: '#ff0000',
          lineWidth: 10,
          lineOpacity: 0.75,
          lineCap: 'round',
          lineJoin: 'round',
          textFill: '#000000',
          textSize: 12,
          textHaloRadius: 2,
          textHaloFill: '#ffffff'
        }
      })
    }
  },
  data () {
    return {
      mapObject: null,
      // mapMarker: null,
      ready: false
    }
  },
  mounted () {
    const vectorLayer = this.$parent.mapObject

    const options = {
      ...this.options
    }

    options.symbol = {
      ...options.symbol,
      lineWidth: this.lineWidth,
      lineColor: this.lineColor
    }

    const lineLayer = createLineLayer({
      coordinates: this.coordinates,
      options
    })

    lineLayer.addTo(vectorLayer)

    // this.attachMapTooltip({
    //   parent: vectorLayer,
    //   layer: lineStringLayer,
    //   textName: this.textName
    // })

    this.mapObject = lineLayer
    this.ready = true
  },
  // watch: {
  //   lineWidth (newValue) {
  //     if (!this.mapObject) return

  //     this.mapObject.updateSymbol({ lineWidth: newValue })
  //   }
  // },
  beforeDestroy () {
    this.mapObject.remove()
    // this.mapMarker.remove()
  }
}
</script>

<style scoped>
.maptalks-line-layer {
  display: none;
}
</style>
